/* eslint-disable */

/*
  eruda 微信移动端测试工具
 */
import getUrlParams from './getUrlParams'
const debug = getUrlParams('debug')

let devModeOn = false

function initEruda () {
  require.ensure([], (require) => {
    const eruda = require('eruda')
    eruda.init()
    console.log('%c eruda inited...', 'color:#2196f3;font-size:14px')
  }, 'eruda')

  devModeOn = true
}

export default (function devMode () {
  if (debug === 'true') {
    initEruda()
    return
  }
  const SHAKE_THRESHOLD = 6200
  let lastUpdate = 0
  let x
  let y
  let z
  let lastX
  let lastY
  let lastZ
  if (window.DeviceMotionEvent) {
    window.addEventListener('devicemotion', (eventData) => {
      const acceleration = eventData.accelerationIncludingGravity
      const curTime = new Date().getTime()
      if ((curTime - lastUpdate) > 100) {
        const diffTime = curTime - lastUpdate
        lastUpdate = curTime
        x = acceleration.x
        y = acceleration.y
        z = acceleration.z
        const speed = Math.abs(x + y + z - lastX - lastY - lastZ) / diffTime * 10000
        if (speed > SHAKE_THRESHOLD && !devModeOn) {
          if (window.confirm('开启开发者模式？')) {
            initEruda()
          }
        }
        lastX = x
        lastY = y
        lastZ = z
      }
    }, false)
  }
}())
